import React from 'react';
import Skeleton from 'flow/components/ui-components/Skeleton';

type CallRecordSkeletonProps = {
    count?: number;
};

export const CallRecordSkeleton = ({ count = 7 }: CallRecordSkeletonProps) => (
    <div className="animate-fade w-full max-w-2xl text-gray-200">
        <Skeleton.DateDivider className="my-5" />
        {[...Array(count)].map((_, index) => (
            <CallRecordItemSkeleton key={index} />
        ))}
    </div>
);

export const CallRecordItemSkeleton = () => (
    <div className="animate-fade flex gap-3 p-2 text-gray-200">
        <Skeleton.Icon className="size-6" />
        <div className="flex grow gap-1">
            <div className="flex w-full flex-col gap-y-3 pt-1">
                <div className="flex items-center justify-between">
                    <Skeleton.Title className="h-4 w-24" />
                    <Skeleton.Text className="w-12" />
                </div>
                <Skeleton.Title className="w-16" />

                <div className="flex flex-row gap-x-1">
                    <Skeleton.Title className="w-8" />
                    <Skeleton.Title className="w-16" />
                </div>
            </div>
        </div>
    </div>
);

export default CallRecordSkeleton;
